import { render, staticRenderFns } from "./ApexChartDataScience.vue?vue&type=template&id=77405330&"
import script from "./ApexChartDataScience.vue?vue&type=script&lang=js&"
export * from "./ApexChartDataScience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports